import React from "react";

const EducationIcon = (props) => {
  return (
    <svg
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1185 20.9998C9.93132 20.9998 6.64648 18.806 6.64648 16.0047C6.64648 15.6391 6.94135 15.3442 7.30699 15.3442C7.67263 15.3442 7.9675 15.6391 7.9675 16.0047C7.9675 17.9921 10.7805 19.6729 14.1126 19.6729C17.4446 19.6729 20.2576 17.9921 20.2576 16.0047C20.2576 15.6391 20.5525 15.3442 20.9181 15.3442C21.2838 15.3442 21.5786 15.6391 21.5786 16.0047C21.5786 18.806 18.2997 20.9998 14.1067 20.9998H14.1185Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M20.9304 16.6652C20.5647 16.6652 20.2699 16.3703 20.2699 16.0046V12.5724C20.2699 12.2067 20.5647 11.9119 20.9304 11.9119C21.296 11.9119 21.5909 12.2067 21.5909 12.5724V16.0046C21.5909 16.3703 21.296 16.6652 20.9304 16.6652ZM7.31334 16.6652C6.9477 16.6652 6.65283 16.3703 6.65283 16.0046V12.5724C6.65283 12.2067 6.9477 11.9119 7.31334 11.9119C7.67898 11.9119 7.97384 12.2067 7.97384 12.5724V16.0046C7.97384 16.3703 7.67898 16.6652 7.31334 16.6652Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M14.0003 16.1933C13.8529 16.1933 13.7055 16.1638 13.5698 16.0989L1.54506 10.5259C1.17942 10.3549 0.955322 9.99516 0.955322 9.59414C0.955322 9.19312 1.18532 8.83928 1.54506 8.66825L13.5698 3.09523C13.847 2.96549 14.1596 2.97139 14.4308 3.09523L26.4556 8.66825C26.8212 8.83928 27.0453 9.19312 27.0453 9.59414C27.0453 9.99516 26.8212 10.349 26.4556 10.52L14.4249 16.0989C14.2893 16.1638 14.1419 16.1933 13.9944 16.1933H14.0003ZM2.70095 9.59414L14.0003 14.831L25.2997 9.59414L14.0003 4.35727L2.70095 9.59414Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M24.9821 17.0134C24.6578 17.0134 24.357 16.8247 24.2214 16.5239L23.8321 15.6747C23.7319 15.4565 23.7319 15.2029 23.8321 14.9788L24.2214 14.1296C24.357 13.8347 24.6519 13.6401 24.9821 13.6401C25.3124 13.6401 25.6073 13.8288 25.7429 14.1296L26.1321 14.9788C26.2324 15.197 26.2324 15.4506 26.1321 15.6747L25.7429 16.518C25.6073 16.8129 25.3065 17.0075 24.9821 17.0075V17.0134Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M24.9816 14.7371C24.6277 14.7371 24.3387 14.4481 24.3387 14.0942V10.544C24.3387 10.1902 24.6277 9.90121 24.9816 9.90121C25.3354 9.90121 25.6244 10.1902 25.6244 10.544V14.0942C25.6244 14.4481 25.3354 14.7371 24.9816 14.7371Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default EducationIcon;
